import { render, staticRenderFns } from "./VerifyForm.vue?vue&type=template&id=8a1e2364&scoped=true&"
import script from "./VerifyForm.vue?vue&type=script&lang=js&"
export * from "./VerifyForm.vue?vue&type=script&lang=js&"
import style0 from "./VerifyForm.vue?vue&type=style&index=0&id=8a1e2364&prod&lang=css&"
import style1 from "./VerifyForm.vue?vue&type=style&index=1&id=8a1e2364&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1e2364",
  null
  
)

export default component.exports